export default "__VITE_ASSET__BRUfC1V6__"